import { colorsPalettes } from "@similarweb/styles";

export const NT_DUNNINGS_EVENT_NAME = "dunning NT account";
export const RESTART_TRIAL_DUNNINGS_EVENT_NAME = "dunning restart trial";
export const REACTIVATE_ACCOUNT_DUNNING_EVENT_NAME = "dunning reactivation";

export const DUNNINGS_POP_UP_CTA_LOCATION = "pop up";
export const DUNNINGS_INLINE_BANNER_CTA_LOCATION = "inline banner";
export const DUNNINGS_SITEWIDE_BANNER_CTA_LOCATION = "sitewide banner";

export const DUNNINGS_UPDATE_BILLING_EVENT_SUB_SUB_NAME = "update billing";
export const DUNNINGS_RESTART_TRIAL_EVENT_SUB_SUB_NAME = "restart trial";
export const DUNNINGS_REACTIVATE_ACCOUNT_EVENT_SUB_SUB_NAME = "reactivate account";

export const DUNNINGS_MODAL_LOCAL_STORAGE_KEY = "dunnings.modal.last.shown";

export const DUNNINGS_MODAL_STYLES: ReactModal.Styles = {
    content: {
        display: "flex",
        width: "fit-content",
        height: "460px",
        background: colorsPalettes.carbon[0],
        padding: "16px",
        borderRadius: "8px",
    },
};
